<template>
  <div>
    <el-dialog v-dialog-drag :visible.sync="showDialog" width="950px" :destroy-on-close="true" :before-close="cancel"
      title="审核信息" class="change-detail-dialog">
      <div class="el-dialog-div">
        <!-- 审核表单区域 -->
        <div class="section-card audit-section">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <el-button size="small" type="success" icon="el-icon-check" @click="handleApprove">确认审核</el-button>
          </div>
          <el-form :model="form" label-width="100px" ref="form" :rules="rules" class="audit-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="审核状态" prop="status">
                  <el-radio-group v-model="form.status">
                    <el-radio label="SUCCESS" class="success-radio">
                      <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                    </el-radio>
                    <el-radio label="DEFEAT" class="danger-radio">
                      <i class="el-icon-error" style="color: #f56c6c;"></i> 拒绝
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.status === 'DEFEAT'">
              <el-col :span="24">
                <el-form-item label="驳回理由" prop="rejectionReason">
                  <el-input type="textarea" v-model="form.rejectionReason"
                    placeholder="请输入合同变更审核理由"
                    :rows="3"
                    maxlength="500"
                    show-word-limit></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 变更内容（共享组件） -->
        <contract-change-sections
          :change-data="changeData"
          :old-data="oldData"
          :new-data="newData"
          project-title="项目变更信息"
          project-change-type="audit">
        </contract-change-sections>
      </div>
      <loading :loading="loading" load-text="提交中"></loading>
    </el-dialog>
  </div>
</template>

<script>
import { auditInfo } from "@/api/dilivery/audit";
import Loading from "@/components/loading/Loading.vue";
import ContractChangeSections from "@/components/sales/ContractChangeSections.vue";
import changeContractMixin from "@/mixins/changeContractMixin";

export default {
  name: "ChangeContractAudit",
  mixins: [changeContractMixin],
  components: { ContractChangeSections, Loading },
  props: ['showDialog', 'selectDetail'],
  data() {
    return {
      loading: false,
      form: {
        id: '',
        status: '',
        rejectionReason: ''
      },
      rules: {
        status: [{ required: true, message: '变更审核不能为空', trigger: 'change' }],
        rejectionReason: [{ required: true, message: '审核原因不能为空', trigger: 'change' }],
      }
    };
  },
  watch: {
    selectDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id;
        }
      },
      immediate: true
    },
  },
  methods: {
    async handleApprove() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          auditInfo(this.form).then(res => {
            this.loading = false;
            if (res.code === 200) {
              this.$messageUi.success('提交成功');
              this.$emit('submit', 'confirm');
              if (this.form.status === 'SUCCESS') {
                this.$messageUi.success('已通过');
              } else {
                this.$messageUi.success('已驳回');
              }
              this.$store.commit('right/setChangeRed', true);
            }
          }).catch(err => {
            this.loading = false;
          });
        } else {
          this.$messageUi.error('信息填写不完整，请检查');
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/contractChangeSections.scss";

.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}
.audit-form {
  padding: 16px;
}
.success-radio {
  margin-right: 20px;
}
.danger-radio {
  margin-right: 0;
}
</style>
